import React from 'react'
import { useCallback, useMedia } from 'sb-hooks'

import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import s from './Tag.scss'


type TagProps = {
  id: number
  name: string
  image: string
  onClick: (id: number) => void
}

const Tag: React.FunctionComponent<TagProps> = ({ id, name, image, onClick }) => {
  const { isMobile } = useMedia()

  const handleClick = useCallback(() => {
    onClick(id)
  }, [ id, onClick ])

  return (
    <button
      className={s.tag}
      type="button"
      onClick={handleClick}
    >
      <img
        className={s.image}
        src={image}
        alt={name}
        draggable={false}
      />
      <Box mt={24}>
        <Text
          message={name}
          size={isMobile ? '16-20' : '14-16'}
          noWrap
        />
      </Box>
    </button>
  )
}

export default Tag
